import React from 'react';
import { Helmet } from 'react-helmet-async';
import './Legal.css';

function AboutPage() {
  return (
    <>
      <Helmet>
        <title>Hakkımızda | MEBS İpek Aksesuar</title>
        <meta name="description" content="MEBS İpek Aksesuar hakkında bilgi edinin. Premium ipek eşarp ve şal üretiminde kalite ve güven." />
      </Helmet>
      <div className="legal-container">
        <div className="legal-header">
          <h1 className="legal-title">Hakkımızda</h1>
          <p className="legal-subtitle">MEBS İpek Aksesuar</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>Biz Kimiz?</h2>
            <p>
              MEBS İpek Aksesuar, premium kalite ipek eşarp, şal ve aksesuarlar üreten ve satan bir Türk markasıdır.
              Kalite ve zarafetin bir arada bulunduğu ürünlerimizle müşterilerimize en iyi alışveriş deneyimini sunmayı hedefliyoruz.
            </p>
          </section>

          <section className="legal-section">
            <h2>Misyonumuz</h2>
            <p>
              El işçiliği ile özenle üretilen ipek ürünlerimizi, müşterilerimize güvenli, hızlı ve kaliteli bir şekilde ulaştırmak
              temel misyonumuzdur. Her ürünümüz, titizlikle seçilmiş hammaddelerden üretilmekte ve kalite kontrolünden geçirilmektedir.
            </p>
          </section>

          <section className="legal-section">
            <h2>Ürünlerimiz</h2>
            <p>
              Koleksiyonumuzda ipek eşarplar, şallar, fularlar ve çeşitli ipek aksesuarlar bulunmaktadır.
              Tüm ürünlerimiz doğal ipek kullanılarak üretilmekte olup özel hediye kutusu seçeneğiyle sunulmaktadır.
            </p>
          </section>

          <section className="legal-section">
            <h2>Güvenli Alışveriş</h2>
            <p>
              Sitemizde gerçekleştirilen tüm ödeme işlemleri iyzico altyapısı üzerinden SSL şifreleme teknolojisiyle güvence altına alınmaktadır.
              Kişisel bilgileriniz ve ödeme bilgileriniz hiçbir şekilde üçüncü şahıslarla paylaşılmamaktadır.
            </p>
          </section>

          <section className="legal-section">
            <h2>İletişim</h2>
            <p>
              Sorularınız ve talepleriniz için bize <strong>iletisim@mebssilk.com</strong> adresinden ulaşabilirsiniz.
            </p>
          </section>

          <section className="legal-section">
            <h2>Ticari Bilgiler</h2>
            <p>
              Şirket Ünvanı: Beyhan Bağlar <br/>
              Vergi Dairesi: Kozyatağı <br/>
              Vergi Numarası (VKN): 1310175107 <br/>
            </p>
          </section>
        </div>
      </div>
    </>
  );
}

export default AboutPage;
